import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {CircleCheckIcon} from "../../../../../SVGElements";
import {SubscriptionCoverageStore} from "../../../../../../client/state/SubscriptionCoverageStore";


class PerkStyle extends StyleSheet {
    @styleRule
    perkElement = {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRule
    checkIcon = {
        marginRight: 12,
        transform: "translateY(4px)",
        alignSelf: "normal",
    };
}

@registerStyle(PerkStyle)
export class Perk extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            text: null
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.perkElement);
    }

    render() {
        return [
            <CircleCheckIcon className={this.styleSheet.checkIcon}/>,
            <div>{this.options.text}</div>
        ];
    }
}

class CoverageStyle extends StyleSheet {
    @styleRule
    coverageElement = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
        margin: "auto",
        width: this.themeProps.FIT_CONTENT,
    }
}

@registerStyle(CoverageStyle)
export class Coverage extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            coverageId: null,
        }
    }

    render() {
        const subscriptionCoverage = SubscriptionCoverageStore.filter(coverage => coverage.isAvailable()).find(coverage => coverage.id === this.options.coverageId);
        return <div className={this.styleSheet.coverageElement}>{subscriptionCoverage?.getName()}</div>
    }
}
